import React from 'react';
import { createListSection } from '../ListSection';
import { SectionItem } from '../SectionItem';
import { Highlight } from '../Highlight';
import { Date } from '../Date';
import { MarketOddsDisplay } from '../MarketOddsDisplay';
function MatchElement({ value, highlights, position }) {
    var _a, _b;
    const sport = ((_a = value.sport) === null || _a === void 0 ? void 0 : _a.slug) || 'event';
    const href = `${sport}/${encodeURIComponent(value.id)}/${value.slug}`;
    const inPlay = value.isInPlay;
    const searchSection = 'Matches';
    const bet = value.primaryBetting ? (React.createElement(MarketOddsDisplay, { className: "WhSearch-SectionItem__bet", value: value.primaryBetting, position: position, searchSection: searchSection, matchId: value.id })) : null;
    return (React.createElement(SectionItem, { expectedTitle: 1, expectedDescription: 1, cutDescription: 2, internalLink: true, href: href, id: value.id, searchSection: searchSection, position: position, inPlay: inPlay },
        React.createElement("div", { className: "WhSearch-SectionItem__title" },
            React.createElement(Highlight, { highlighted: highlights.name, content: value.name })),
        React.createElement("div", { className: "WhSearch-SectionItem__description" },
            React.createElement(Date, { datetime: value.startTime }),
            ' - ',
            React.createElement(Highlight, { highlighted: highlights['competition.name'], content: (_b = value.competition) === null || _b === void 0 ? void 0 : _b.name })),
        bet));
}
export const MatchSection = createListSection(MatchElement, {
    title: 'sectionMatchesTitle',
});
//# sourceMappingURL=MatchSection.js.map